import { Link, useWorkflowStep } from "@bcm-dev/bcms-vite";
import { FormContainer, FormRowView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { UIButton } from "components/ui";
import { getDefault, getWorkflowSteps } from "components/workflows/AdvancedAlertsAddPhoneWorkflow";
import { SVGAsset } from "res";

import UIPhoneNumberWithFormat from "components/ui/UIPhoneNumberWithFormat";
import "./styles.css";

export default function AddPhoneContent(props) {
    const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);
    let { phone } = workflowStep.getStepState;
    const data = { ...getDefaultPageData(), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

    phone = data.phone ? data.phone : phone;

    const onChange = value => workflowStep.update([ "phone" ], value);
    const onSubmit = evt => {
        const recipient = !phone || phone.length === 0 || phone.replace(/[\s()-]/g, "").length !== 10
            ? "(508) 123-4567" : phone;

        workflowStep.workflow.nextStep({ recipient });
    };

    return (
        <div className="add-phone-content back-link-padding">
            <Link to="/advancedAlerts/manageRecipients" className="back-link">
                <span><SVGAsset id="LeftChevronIcon" /> Back</span>
            </Link>

            <p className="page-subtitle">Add Phone</p>

            <FormContainer className="small-form-width">
                <FormRowView text="Phone Number *">
                    <UIPhoneNumberWithFormat value={ phone } dataPoint="Add_Phone_Input" onChange={ onChange } placeholder="(###) ###-####" />
                </FormRowView>

                <FormButtonRow>
                    <UIButton className="primary-button set-width" text="Submit" dataPoint="Add_Phone_Submit_Button" onClick={ onSubmit } />
                </FormButtonRow>
            </FormContainer>
        </div>
    );
}

export const getDefaultPageData = () => ({
 
});

export const getDefaultPageUI = () => ({
  
});